














































import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
	emits: ["input"],
	props: {
		value: {
			type: String,
			default: "en",
		},
	},
	setup(props, context) {
		const val = computed({
			get() {
				return props.value;
			},
			set(v) {
				context.emit("input", v);
			},
		});

		const options = computed(() => {
			return [
				{ value: "en", text: "ENGLISH", icon:"🇬🇧", shortText:"EN", tooltip:"English" },
				{ value: "is", text: "ICELANDIC", icon:"🇮🇸", shortText:"IS", tooltip:"Icelandic" },
			];
		});

		return {
			val,
			options,
		};
	},
});
